export default __webpack_public_path__ + "static/media/Ujjain-1.46870f07.jpg";